import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';


export const editTaskVisit = ({
                                taskID,
                                shumaID,
                                taskStatus,
                                dueDate,
                                notes,
                                visitContactName,
                                visitContactPhone
                              }) => {
  const data = {
    taskID: parseInt(taskID, 10),
    shumaID: parseInt(shumaID, 10),
    taskStatus,
    dueDate,
    notes,
    visitContactName,
    visitContactPhone
  };

  return axios.post(api.EDIT_TASK_VISIT, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

    })
    .catch((err) => {
      console.error('Edit taskVisit returns error:');
      console.error(err);
    });
};

export const editTaskGeneral = ({
                                  taskID,
                                  shumaID,
                                  taskStatus,
                                  dueDate,
                                  taskDescription
                                }) => {
  const data = {
    taskID: parseInt(taskID, 10),
    shumaID: parseInt(shumaID, 10),
    taskStatus: parseInt(taskStatus, 10),
    dueDate,
    taskDescription
  };

  return axios.post(api.EDIT_TASK_GENERAL, data)
    .then(response => {
      const {errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

    })
    .catch((err) => {
      console.error('Edit taskGeneral returns error:');
      console.error(err);
    });
};
